import { Component, DestroyRef, inject } from '@angular/core';

import { LayoutService } from '../../services/layout.service';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../../../core/constant/product.constant';

@Component({
    standalone: false,
    selector: 'app-auth-shell',
    templateUrl: './auth-shell.component.html',
})
export class AuthShellComponent {
    protected readonly productName = PRODUCT_NAME;
    protected readonly supportEmail = SUPPORT_EMAIL;

    constructor() {
        const layoutService = inject(LayoutService);
        layoutService.useSignInLook(true);
        inject(DestroyRef).onDestroy(() => layoutService.useSignInLook(false));
    }
}
